<template>
  <div>
    <PageHeader :schema="$schemas.bank" />
    <PageContent>
      <DynamicFormPage :schema="$schemas.bank" :service="$api.banks" />
    </PageContent>
  </div>
</template>

<script>
import PageHeader from '@/components/PageHeader';
import PageContent from '@/components/PageContent';
import DynamicFormPage from '@/components/dynamics/DynamicFormPage';

export default {
  name: 'CreateBank',
  components: { PageHeader, PageContent, DynamicFormPage },
};
</script>
